<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Api Payment" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 ">
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <SearchSelect
                      v-model="selectedStore"
                      @selectedFullObj="selectedFullObj"
                      url="v1/get-stores"
                      :extract-options="(res) => res.data?.stores || []"
                      placeholder="Search Store..."
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Channel</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="align-items-center mx-50 row mt-1  pb-2">
<!--            <div class="col-md-4 user_role">-->
<!--              <SelectOptions-->
<!--                label=""-->
<!--                selectAppend="account"-->
<!--                labelValue="currency.code"-->
<!--                v-model="selectedAccount"-->
<!--                :url="showSelectAccountOption"-->
<!--                :externalData="$store.getters.getAccountData"-->
<!--              />-->
<!--            </div>-->
            <div class="col-md-4 user_status">
              <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-md-4 user_status">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-2 btn btn-dark" @click="onClearFilters">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/get-api-payments"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="[]"
              customClass="table-hover-animation"
              :filteredData="filteredData"
          />
        </div>
      </div>
    </div>
  </div>


  <RefundModal :show="showRefundModal" :transactionId="transactionId" :refundInitialAmount="refundInitialAmount"
               @hide="showRefundModal = false"></RefundModal>
</template>

<script>

import SearchSelect from "@/components/common/SearchSelect.vue";

export default {
  components: {SearchSelect},
  mounted() {
    this.showSelectAccountOption = 'v1/get-wallet-list'
    this.showSelectTypesOption = 'v1/transaction-types'
  },
  data() {
    return {
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'payment_links',
            payment_type: 2,
          }

          if(this.selectedStore){
            requestData.storeId = this.selectedStore
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }

          if(this.search != '') {
            requestData.transactionId = this.search
          }



          if (this.selectedType) {
            requestData.transactionTypeId = this.selectedType.id

          }
          if (this.selectedAccount) {
            requestData.userAccountId = this.selectedAccount.id

          }

          this.downloadReport(requestData)
        }
      },
      refundInitialAmount:'',
      showRefundModal: false,
      clearStores: false,
      transactionId: '',
      breadcrumb: [
        {name: 'App'},
        {name: 'Api Payment'},
      ],
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'token',
          html: true,
          alter: (value,row) => {
            var html = ''
            if(row.transactions.length > 0){
              if(row.transactions[0].application == 'DIRECT_API_PAYMENT'){
                html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div class=""><span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span></div>
                        <div class="badge badge-light-info mt-1">Direct Api Payment</div>
                    </div>
                </div>
                `

              }else{
                html = `<span class="text-primary" style="cursor: pointer" title="Click For Details" >${value}</span>`
              }
            }else{
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details" >${value}</span>`
            }



            return html


          },
              cta: (row) => {
                this.$router.push({name: 'transactions-details-with-id',params: {id:row.token}})
              }
        },
        {
          title: 'Status',
          valueKey: 'status_str',
          html: true,
          alter:  (value, obj) => {

            var givenDate = new Date(obj.created_at);
            var givenSeconds = givenDate.getTime() / 1000;
            var currentDate = new Date();
            var currentSeconds = currentDate.getTime() / 1000;



            var html = ''
            if (obj.status == 1)
              html = `<div class="badge  badge-success">Initiated</div>`
            else if (obj.status == 2)
              html = `<div class="badge  badge-danger">${value}</div>`
            else
              html = `<div class="badge  badge-warning">${value}</div>`


            if ((obj.exipres_in < (currentSeconds-givenSeconds)) && obj.status == 1) {
              html = `
                <div class="row">
                <div class="col-12">
                <div class="badge  badge-light-success">Initiated</div>
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.5rem">Expired</div></p></div>`

            }

            return html


          }
        },
        {
          title: 'Customer',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0){
              if(value[0]?.customer?.name){
                html = ` <a href="javascript:void()" class="text-dark">${value[0].customer?.name}</a>`
              }
            }


            return html

          }
        },
        {
          title: 'Customer Email',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'

            if(value.length > 0){
              if(value[0]?.customer?.email){
                html = ` <a href="javascript:void()" class="text-dark">${value[0].customer?.email}</a>`
              }
            }


            return html


          }
        },
        {
          title: 'Sender Account Title',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="badge badge-light-dark">${value[0].sender_account_title}</a>`

            return html


          }
        },
        {
          title: 'Sender Account Num',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${value[0].sender_account_number}</a>`

            return html


          }
        },
        {
          title: 'Receiver Account Title',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="badge badge-light-warning">${value[0].receiver_account_title}</a>`
            else{
              if(row.added_by_user && Object.keys(row.added_by_user).length > 0)
                html = ` <a href="javascript:void()" class="badge badge-light-warning">${(row.added_by_user.first_name).toUpperCase()+' '+(row.added_by_user.last_name).toUpperCase()}</a>`
            }

            return html


          }
        },
        {
          title: 'Schemas',
          valueKey: 'schemas',
          html: true,
          alter:  (value, obj) => {
            var html = ''
            if (value) {
              html = `<div class="grid">`
              if (obj.schemas.length) {
                obj.schemas.forEach((item) => {

                  html += `<div class="row"><div class="badge badge-light-primary mt-sm-1">${item.name}</div></div>`
                })
              }

              html += ` </div>`
            }


            return html
          }
        },
        {
          // title: 'Total Amount',
          title: 'Amount',
          // valueKey: 'total_amount',
          valueKey: 'amount',
          html: true,
          alter:  (value,row) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</span><div class="badge badge-light-success ml-sm-1">${row.currency.code}</div>`


            return html


          }
        },
        {
          title: 'Vat',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${parseFloat(value[0].vat / 100).toFixed(this.feesDecimalPlaces)}</a>`

            return html


          }
        },
        {
          title: 'Fees',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${parseFloat(value[0].fee / 100).toFixed(this.feesDecimalPlaces)}</a>`

            return html


          }
        },
        // {
        //   title: 'Payable Amount',
        //   valueKey: 'amount',
        //   html: true,
        //   alter:  (value,row) => {
        //     var html = ''
        //     if (value)
        //       html = `<span  class=" font-weight-bolder text-dark">${parseFloat((value-row.vat-row.fee)/100).toFixed(this.amountDecimalPlaces)}</span>&nbsp;<div class="badge badge-light-success">${row.currency.code}</div>`
        //
        //
        //     return html
        //
        //
        //   }
        // },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        // {
        //   title: 'Refund',
        //   class: 'btn-danger mt-1',
        //   cta: (row) => {
        //     this.transactionId = row.uuid
        //     this.refundInitialAmount = parseFloat(row.total_amount/100).toFixed(this.amountDecimalPlaces
        //     )
        //     this.showRefundModal = true
        //   }
        // },
        {
          title: 'Attempts',
          class: 'btn-primary mt-1 ml-1',
          cta: (row) => {
            this.$router.push({name: 'payment-link-attempt',params: {id:row.token}})
          }
        },
      ],
      // actions: [
      //
      // ],
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      search: '',
      selectedAccount: null,
      selectedType: null,
      filteredData: {},
      transactionRequestSelectedData: null,
      transactionRequestSelectedIndex: 0,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
    }
  },
  methods: {
    selectedFullObj(obj){
      if(obj){
        this.terminalData = obj.terminals
      }else{
        this.terminalData = []
      }
    },
    onSubmitFilters() {
      let dataFiltered = {}

      if(this.selectedStore){
        dataFiltered.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel.id
      }



      if (this.search != '' && this.selectedType && this.selectedAccount) {
        dataFiltered.transactionId = this.search
        dataFiltered.transactionTypeId = this.selectedType.id
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search != '' && this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionId = this.search
        dataFiltered.transactionTypeId = this.selectedType.id

      } else if (this.search != '' && !this.selectedType && this.selectedAccount) {

        dataFiltered.transactionId = this.search
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search != '' && !this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionId = this.search

      } else if (this.search == '' && this.selectedType && this.selectedAccount) {

        dataFiltered.transactionId = this.search
        dataFiltered.userAccountId = this.selectedAccount.id

      } else if (this.search == '' && this.selectedType && !this.selectedAccount) {

        dataFiltered.transactionTypeId = this.selectedType.id

      } else if (this.search == '' && !this.selectedType && this.selectedAccount) {

        dataFiltered.userAccountId = this.selectedAccount.id

      }
      this.filteredData = dataFiltered


    },
    onClearFilters() {
      this.selectedType = null
      this.selectedAccount = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}

    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>

